import { Button, Flex, Title } from "@qws-org/ui-kit";
import type { FC } from "react";

import { isExternalLink, isInternalLink } from "~/core/utils/action.utils";

import type { CardGalleryProps } from "../CardGallery";
import { ColumnCard } from "./ColumnCard";

export const Column: FC<CardGalleryProps> = (props) => {
  const { data, getUrl, isControlInactive, onCallAction, ...rest } = props;
  const controlAction = data?.action;
  const action = data.action?.action?.[0];
  const isInactive = controlAction ? isControlInactive(controlAction) : true;
  let href;
  if (isExternalLink(action?.item)) {
    href = action.item.href ?? undefined;
  }
  if (isInternalLink(action?.item)) {
    href = action.item.page ? getUrl(action.item.page) : undefined;
  }
  const handlePressButton = (): void => {
    if (controlAction) {
      onCallAction(controlAction);
    }
  };
  return (
    <Flex
      as="section"
      maxWidth="inherit"
      width="100%"
      flexDirection="column"
      p={{ py: 32, px: 15 }}
      {...rest}
      d={{ p: { py: 64 }, ...rest.d }}
    >
      <Title
        as="h2"
        size="medium"
        fontWeight="desktop.semibold"
        horizontalAlign="center"
        md={{ horizontalAlign: "left" }}
        m={{ mb: 32 }}
        d={{ m: { mb: 64 } }}
      >
        {data.title}
      </Title>
      <Flex
        flexDirection="column"
        gap={24}
        justify="center"
        align="center"
        d={{ gap: 20 }}
      >
        {data?.cards?.map(
          (card) => card && <ColumnCard key={card.id} {...props} card={card} />,
        )}
      </Flex>

      {!isInactive && (
        <Flex
          align="center"
          justify="center"
          m={{ mt: 24 }}
          md={{ m: { mt: 48 } }}
        >
          <Button
            onPress={handlePressButton}
            href={href}
            size="small"
            fontWeight="desktop.bold"
            p={{ py: 12, px: 24 }}
            d={{ p: { py: 16, px: 48 } }}
            whiteSpace="pre-wrap"
          >
            {data.action_text}
          </Button>
        </Flex>
      )}
    </Flex>
  );
};
